module.exports = __webpack_public_path__ + "img/education.c093c417.png";